import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.7_@playwright+test@1.61.0_babel-plugin-macros@3.1.0_react_58289da27f5c1b09d1e18101755af421/node_modules/next/dist/client/link.js");
